import React from 'react';
import { Drawer, DrawerContent, DrawerFooter, DrawerHeader } from 'fronton-react';
import { ButtonWithGAClickButton, Typography } from 'common/components';
import { lowerBoundsBreakpoints } from 'common/styles/breakpoints';
import { fullWidthMobileButton } from 'common/styles/common';
import { createElementKey } from 'utils';
import { KITCHEN_PRICE_PDP_CDN_PATH } from '../../kitchen-price-pdp-constants';
import { COLLECTION_COMPOSITION_LIST } from './collection-composition-constants';
import {
  collectionCompositionDisclaimer,
  collectionCompositionImage,
  collectionCompositionText,
  collectionCompositionTextRow,
  collectionCompositionTextWrapper,
} from './collection-composition-styles';

type CollectionCompositionProps = {
  basketHref: string;
  elementBlock: string;
  onClose: TFunction;
  show: boolean;
}

export const CollectionComposition: React.FC<CollectionCompositionProps> = ({ basketHref, elementBlock, show, onClose }) => (
  <Drawer show={show} size="s" onClose={onClose}>
    <DrawerHeader onClickBack={onClose} title="Cтандартая комплектация 240 см" />
    <DrawerContent>
      <div>
        <picture>
          <source
            srcSet={`${KITCHEN_PRICE_PDP_CDN_PATH}/collection-composition/scheme-ld.jpg/scheme-ld.jpg`}
            media={lowerBoundsBreakpoints['--from-large-desktop']}
          />
          <source
            srcSet={`${KITCHEN_PRICE_PDP_CDN_PATH}/collection-composition/scheme-t.jpg/scheme-t.jpg`}
            media={lowerBoundsBreakpoints['--from-tablet']}
          />
          <img
            alt="Изображение размеров кухни"
            className={collectionCompositionImage}
            src={`${KITCHEN_PRICE_PDP_CDN_PATH}/collection-composition/scheme-m.jpg/scheme-m.jpg`}
          />
        </picture>
      </div>

      <div className={collectionCompositionTextWrapper}>
        {COLLECTION_COMPOSITION_LIST.map(({ name, quantity }, index: number) => (
          <div
            className={collectionCompositionTextRow}
            key={createElementKey('collection-composition', index)}>
            <div className={collectionCompositionText}>
              <Typography variant="m" size="body_long">
                {name}
              </Typography>
              <Typography variant="m" size="body_long">
                {quantity}
              </Typography>
            </div>
          </div>
        ))}
      </div>

      <div className={collectionCompositionDisclaimer}>
        <Typography size="body_accent" variant="m">
          Цена указана за&nbsp;стандартную комплектацию 240&nbsp;см
        </Typography>
        <Typography size="body_long" variant="s">
          В&nbsp;стоимость не&nbsp;входят: столешница, стеновая панель, мойка, смеситель, дверные ручки, а&nbsp;также фурнитура для крепления шкафов на&nbsp;стену.
        </Typography>
      </div>
    </DrawerContent>
    <DrawerFooter>
      <ButtonWithGAClickButton
        className={fullWidthMobileButton}
        elementBlock={`${elementBlock} / Equipment`}
        elementName="Cтандартая комплектация 240 см"
        elementText="Записаться на проектирование"
        title="Записаться на проектирование"
        href={basketHref}
        target="_blank"
        wide
      >
        Записаться на проектирование
      </ButtonWithGAClickButton>
    </DrawerFooter>
  </Drawer>
);
